export interface Testimonial {
  id: number;
  author: string;
  role: string;
  location: string;
  course: string;
  courseSlug: string;
  rating: number;
  text: string;
  datePublished: string;
}

export const testimonialsData: Testimonial[] = [
  {
    id: 1,
    author: "Suresh R.",
    role: "Power BI Developer",
    location: "Dallas, TX",
    course: "Power BI",
    courseSlug: "/courses/power-bi",
    rating: 5,
    text:
      "The Power BI training at Seasoft was unlike anything I'd tried before. The instructor didn't just teach the tool - he walked us through real business scenarios from his own consulting projects. I went from zero BI knowledge to landing a Sr. Power BI Developer role in under three months.",
    datePublished: "2024-10-01",
  },
  {
    id: 2,
    author: "Meena A.",
    role: "Drug Safety Associate",
    location: "Chicago, IL",
    course: "Drug Safety Associate",
    courseSlug: "/courses/drug-safety-associate",
    rating: 5,
    text:
      "I was working as a nurse and wanted to pivot into the healthcare IT space. Seasoft's Drug Safety Associate program was exactly what I needed. The curriculum covered pharmacovigilance end-to-end, and the placement team helped me get my first interview within weeks of completing the course.",
    datePublished: "2024-10-01",
  },
  {
    id: 3,
    author: "Raj P.",
    role: "Salesforce Administrator",
    location: "New Jersey",
    course: "Salesforce Administrator",
    courseSlug: "/courses/salesforce-administrator",
    rating: 5,
    text:
      "I'd tried a few online platforms before Seasoft, but none of them felt like real training. The live sessions, the ability to ask questions, and the instructor's industry knowledge made all the difference. I passed my Salesforce Admin certification on the first attempt.",
    datePublished: "2024-10-01",
  },
  {
    id: 4,
    author: "Divya K.",
    role: "QA Analyst",
    location: "Atlanta, GA",
    course: "QA Testing",
    courseSlug: "/courses/qa-testing",
    rating: 5,
    text:
      "The QA testing course at Seasoft gave me everything I needed to land my first IT job in the US - manual testing fundamentals, Agile methodology, and Selenium basics. The resume review and mock interview support was exceptional.",
    datePublished: "2024-10-01",
  },
  {
    id: 5,
    author: "Karthik M.",
    role: "Business Analyst",
    location: "Houston, TX",
    course: "Business Analysis",
    courseSlug: "/courses/business-analysis",
    rating: 5,
    text:
      "What I appreciated most about Seasoft Classes was the personalized attention. The batches are small, so the instructor actually knows your name and your progress. I completed the Business Analysis course and got placed within 45 days.",
    datePublished: "2024-10-01",
  },
  {
    id: 6,
    author: "Lakshmi N.",
    role: "SAS Analyst",
    location: "Philadelphia, PA",
    course: "SAS - Statistical Analysis",
    courseSlug: "/courses/sas-statistical-analysis",
    rating: 5,
    text:
      "I'm a working professional with two kids, so flexibility was critical for me. Seasoft's weekend batch for SAS programming was perfect. Session recordings meant I never missed content, and the instructor was genuinely invested in our success.",
    datePublished: "2024-10-01",
  },
];
